export default __webpack_public_path__ + "static/img_product_laura@2x-34b43a18c21888f35d0aeb50a5f4cea7.png";